import { put, select } from 'redux-saga/effects';
import BookingActions, { BookingSelectors } from './BookingRedux';
import { UsersSelectors } from './UsersRedux';
import logger from '@utils/logger';
import history from '@utils/history';

export function* fetchBooking(actions) {
  const { bookingId } = actions;
  yield put(BookingActions.setBookingLoading(true));
  const existingBookings = yield select(BookingSelectors.selectBookingsList);

  const users = yield select(UsersSelectors.selectList);

  let found = existingBookings.find(
    item => `${item.bookingID}` === `${bookingId}`
  );

  try {
    if (!found) {
      // const { result } = yield API.fetchRequest(bookingId);
      // found = result;
      yield put(BookingActions.setBookingLoading(false));
      history.push('/requests');
    }
    const { housekeeperID } = found || {};
    let houseKeeper = null;

    if (housekeeperID) {
      houseKeeper = users.find(item => item.userID === housekeeperID);
    }

    // const { result: property } = yield API.fetchProperty(propertyId);
    yield put(
      BookingActions.setBookingData({
        ...found,
        houseKeeper
      })
    );
  } catch (err) {
    logger.error('err: ', err);
  }
  yield put(BookingActions.setBookingLoading(false));
}
